import type { ScheduledProgram } from "./types";

export type ScheduleEventPlacement = { column: number; columns: number };

// Columns exist only inside connected overlap groups. A lone event uses the
// full width regardless of controller, while simultaneous events are packed
// deterministically into the minimum number of columns.
export function packScheduleEvents(items: ScheduledProgram[]): ScheduleEventPlacement[] {
	const placements = items.map(() => ({ column: 0, columns: 1 }));
	const ordered = items.map((item, index) => {
		const start = item.startAt ? new Date(item.startAt).getTime() : Number.NaN;
		return { index, start, end: start + Math.max(1, item.durationSeconds || 1800) * 1000 };
	}).filter((item) => Number.isFinite(item.start)).sort((left, right) => left.start - right.start || left.end - right.end || left.index - right.index);

	let cluster: typeof ordered = [];
	let clusterEnd = Number.NEGATIVE_INFINITY;
	const finishCluster = () => {
		if (!cluster.length) return;
		const columnEnds: number[] = [];
		const assignments: Array<{ index: number; column: number }> = [];
		for (const item of cluster) {
			let column = columnEnds.findIndex((end) => end <= item.start);
			if (column < 0) column = columnEnds.length;
			columnEnds[column] = item.end;
			assignments.push({ index: item.index, column });
		}
		const columns = Math.max(1, columnEnds.length);
		for (const assignment of assignments) placements[assignment.index] = { column: assignment.column, columns };
	};

	for (const item of ordered) {
		if (cluster.length && item.start >= clusterEnd) {
			finishCluster();
			cluster = [];
			clusterEnd = Number.NEGATIVE_INFINITY;
		}
		cluster.push(item);
		clusterEnd = Math.max(clusterEnd, item.end);
	}
	finishCluster();
	return placements;
}
